import { Route } from '@angular/router';
import { accountHistoryResolver } from '@df/account/resolvers/account-history.resolver';
import { apiConfigResolver } from '@df/api/config/api-config.resolver';
import { countriesListResolver } from '@df/api/config/contries-list.resolver';
import { CustomerHistoryOrderResolver } from '@df/session/customer/customer-history-order.resolver';
import { CustomerLoggedGuard } from '@df/session/customer/customer-logged.guard';
import { WishlistLoadResolver } from '@df/session/wishlist/wishlist-load.resolver';
import { StoreCreditAccountResolver } from '../module/store-credit/store-credit-account.resolver';

export const accountRoutes: Route[] = [
    {
        path: '',
        loadComponent: () =>
            import(
                /* webpackChunkName: "account-view.async" */
                './view/account-view.component'
            ).then(c => c.AccountViewComponent),
        canActivate: [CustomerLoggedGuard],
        children: [
            {
                path: '',
                loadComponent: () =>
                    import(
                        /* webpackChunkName: "account-dashboard.async" */
                        './dashboard/account-dashboard.component'
                    ).then(c => c.AccountDashboardComponent),
                resolve: {
                    appData: apiConfigResolver,
                    history: accountHistoryResolver
                }
            },
            {
                path: 'my-details',
                loadComponent: () =>
                    import(
                        /* webpackChunkName: "account-my-details.async" */
                        './my-details/account-my-details.component'
                    ).then(c => c.AccountMyDetailsComponent)
            },
            {
                path: 'saved-cards',
                loadComponent: () =>
                    import(
                        /* webpackChunkName: "account-saved-cards.async" */
                        './saved-cards/account-saved-cards.component'
                    ).then(c => c.AccountSavedCardsComponent)
            },
            {
                path: 'address-book',
                loadComponent: () =>
                    import(
                        /* webpackChunkName: "account-address-book.async" */
                        './address/book/account-address-book.component'
                    ).then(c => c.AccountAddressBookComponent),
                resolve: {
                    countries: countriesListResolver
                }
            },
            {
                path: 'address',
                loadComponent: () =>
                    import(
                        /* webpackChunkName: "account-address-edit.async" */
                        './address/edit/account-address-edit.component'
                    ).then(c => c.AccountAddressEditComponent),
                resolve: {
                    countries: countriesListResolver,
                    appData: apiConfigResolver
                }
            },
            {
                path: 'address/:id',
                loadComponent: () =>
                    import(
                        /* webpackChunkName: "account-address-edit.async" */
                        './address/edit/account-address-edit.component'
                    ).then(c => c.AccountAddressEditComponent),
                resolve: {
                    countries: countriesListResolver,
                    appData: apiConfigResolver
                }
            },
            {
                path: 'my-orders',
                loadComponent: () =>
                    import(
                        /* webpackChunkName: "account-order.async" */
                        './order/account-order.component'
                    ).then(c => c.AccountOrderComponent),
                resolve: {
                    appData: apiConfigResolver,
                    history: accountHistoryResolver
                }
            },
            {
                path: 'order/:id',
                loadComponent: () =>
                    import(
                        /* webpackChunkName: "account-order-view.async" */
                        './order/view/account-order-view.component'
                    ).then(c => c.AccountOrderViewComponent),
                resolve: {
                    appData: apiConfigResolver,
                    historyOrder: CustomerHistoryOrderResolver
                }
            },
            {
                path: 'my-preferences',
                loadComponent: () =>
                    import(
                        /* webpackChunkName: "account-my-preferences.async" */
                        './my-preferences/account-my-preferences.component'
                    ).then(c => c.AccountMyPreferencesComponent)
            },
            {
                path: 'wishlist',
                loadComponent: () =>
                    import(
                        /* webpackChunkName: "account-wishlist.async" */
                        './wishlist/account-wishlist.component'
                    ).then(c => c.AccountWishlistComponent),
                resolve: {
                    wishlist: WishlistLoadResolver
                }
            },
            {
                path: 'store-credit',
                loadComponent: () =>
                    import(
                        /* webpackChunkName: "account-store-credit.async" */
                        '../module/store-credit/account/store-credit-account.component'
                    ).then(c => c.StoreCreditAccountComponent),
                resolve: {
                    enabled: StoreCreditAccountResolver
                }
            }
        ]
    }
];
